import { graphql } from 'msw';

import { hasValidToken } from '../utils';

export const listTrqkEntitiesWithUploadedStatements = graphql.query<
    ListTrqkEntitiesWithUploadedStatementsQuery,
    ListTrqkEntitiesWithUploadedStatementsQueryVariables
>('listTrqkEntitiesWithUploadedStatements', (req, res, ctx) => {
    if (hasValidToken(req, 'publisher')) {
        return res(
            ctx.data({
                listTrqkEntities: {
                    items: [
                        {
                            id: 'test-entity-1',
                            name: 'Test Entity 1',
                            pro: 'ASCAP',
                            role_type: 'publisher' as ProRoleType,
                            ROW_LOCK: '',
                        },
                    ],
                    nextToken: null,
                },
            }),
        );
    }

    return res();
});
